// KC Byte iT - Mock Data
// Este arquivo contém todos os dados mockados para o site
// Será substituído por dados do backend posteriormente

export const siteConfig = {
  companyName: "KC Byte iT",
  tagline: "TI que resolve. Segurança que protege. Automação que escala.",
  email: "contato@kcbyteit.com.br",
  phone: "(11) 95638-0738",
  whatsapp: "5511956380738",
  whatsappMessage: "Olá! Gostaria de saber mais sobre os serviços da KC Byte iT.",
  address: "Atendimento remoto em todo Brasil",
  workingHours: "Segunda a Sexta, 8h às 18h",
  socialLinks: {
    linkedin: "https://linkedin.com/company/kcbyteit",
    instagram: "https://instagram.com/kcbyteit",
    facebook: "https://facebook.com/kcbyteit",
    twitter: "https://twitter.com/kcbyteit"
  }
};

export const heroContent = {
  title: "TI que resolve. Segurança que protege. Automação que escala.",
  subtitle: "Soluções completas em tecnologia da informação para empresas que buscam eficiência, segurança e crescimento sustentável.",
  ctaPrimary: "Solicitar Orçamento",
  ctaSecondary: "Falar no WhatsApp"
};

export const differentials = [
  {
    id: 1,
    icon: "Zap",
    title: "Agilidade e Previsibilidade",
    description: "Entregas rápidas com cronogramas precisos. Metodologias ágeis que garantem resultados no prazo."
  },
  {
    id: 2,
    icon: "Shield",
    title: "Segurança e Compliance",
    description: "Proteção de dados e conformidade com LGPD. Sua empresa segura contra ameaças cibernéticas."
  },
  {
    id: 3,
    icon: "Cog",
    title: "Automação e Redução de Custos",
    description: "Processos automatizados que eliminam tarefas repetitivas e reduzem custos operacionais."
  },
  {
    id: 4,
    icon: "BarChart3",
    title: "Gestão e Observabilidade",
    description: "Monitoramento completo do seu ambiente de TI com dashboards e alertas inteligentes."
  }
];

export const services = [
  {
    id: 1,
    icon: "Search",
    title: "Análise de Vulnerabilidade Técnica (Pentest)",
    description: "Identificação proativa de falhas de segurança antes que sejam exploradas.",
    benefit: "Proteja sua empresa contra invasões"
  },
  {
    id: 2,
    icon: "Globe",
    title: "Criação de Web Sites",
    description: "Sites modernos, responsivos e otimizados para conversão.",
    benefit: "Presença digital que gera resultados"
  },
  {
    id: 3,
    icon: "Server",
    title: "Gerenciamento do GLPI",
    description: "Gestão completa do seu sistema GLPI com suporte especializado.",
    benefit: "Help desk eficiente e organizado"
  },
  {
    id: 4,
    icon: "Puzzle",
    title: "Criação de Plugins Personalizados do GLPI",
    description: "Desenvolvimento de extensões sob medida para suas necessidades.",
    benefit: "GLPI adaptado ao seu negócio"
  },
  {
    id: 5,
    icon: "Link",
    title: "Integrações com APIs",
    description: "Conexão entre sistemas e automação de fluxos de dados.",
    benefit: "Sistemas conectados e inteligentes"
  },
  {
    id: 6,
    icon: "Cloud",
    title: "Gerenciamento do GCP e Google Workspace",
    description: "Administração completa da sua infraestrutura Google Cloud.",
    benefit: "Nuvem otimizada e produtiva"
  },
  {
    id: 7,
    icon: "ShieldCheck",
    title: "Gerenciamento de Cloudflare",
    description: "CDN, proteção DDoS e otimização de performance web.",
    benefit: "Site rápido e protegido"
  },
  {
    id: 8,
    icon: "Lock",
    title: "Gerenciamento de CrowdStrike",
    description: "Proteção endpoint de próxima geração com IA.",
    benefit: "Segurança de nível enterprise"
  },
  {
    id: 9,
    icon: "Workflow",
    title: "Automações com Node.js e n8n",
    description: "Workflows automatizados que conectam suas ferramentas.",
    benefit: "Produtividade multiplicada"
  }
];

export const partners = [
  { id: 1, name: "Google Cloud", logo: "/partners/google-cloud.svg" },
  { id: 2, name: "Cloudflare", logo: "/partners/cloudflare.svg" },
  { id: 3, name: "CrowdStrike", logo: "/partners/crowdstrike.svg" },
  { id: 4, name: "GLPI", logo: "/partners/glpi.svg" },
  { id: 5, name: "n8n", logo: "/partners/n8n.svg" }
];

export const testimonials = [
  {
    id: 1,
    name: "Carlos Eduardo Silva",
    role: "Diretor de TI",
    company: "Indústria Metalúrgica São Paulo",
    content: "A KC Byte iT transformou nossa gestão de TI. O gerenciamento do GLPI e as automações implementadas reduziram nosso tempo de resposta em 60%. Equipe extremamente profissional e comprometida.",
    avatar: null
  },
  {
    id: 2,
    name: "Ana Paula Rodrigues",
    role: "CEO",
    company: "Startup Tech Solutions",
    content: "Contratamos para análise de vulnerabilidade e ficamos impressionados com a profundidade do relatório. Identificaram falhas críticas que poderiam ter custado milhões. Recomendo fortemente.",
    avatar: null
  },
  {
    id: 3,
    name: "Roberto Mendes",
    role: "Gerente de Operações",
    company: "Logística Express Brasil",
    content: "As integrações com APIs desenvolvidas pela equipe conectaram todos os nossos sistemas. Hoje temos visibilidade total das operações e economia de 40% em custos operacionais.",
    avatar: null
  }
];

export const aboutContent = {
  mission: {
    title: "Nossa Missão",
    content: "Democratizar o acesso à tecnologia de ponta, oferecendo soluções de TI que transformam a maneira como empresas operam, crescem e se protegem no ambiente digital. Acreditamos que toda organização, independente do porte, merece acesso a serviços de tecnologia de excelência."
  },
  methodology: {
    title: "Como Trabalhamos",
    content: "Nossa metodologia combina as melhores práticas do mercado com uma abordagem personalizada para cada cliente. Iniciamos com um diagnóstico completo do seu ambiente de TI, identificando oportunidades de melhoria e riscos potenciais. A partir daí, desenvolvemos um plano de ação detalhado, com cronogramas claros e métricas de sucesso definidas.\n\nTrabalhos com sprints semanais, garantindo entregas contínuas e visibilidade total do progresso. Nossa comunicação é transparente e proativa — você sempre sabe exatamente onde estamos e para onde vamos."
  },
  trust: {
    title: "Por que Confiar na KC Byte iT",
    content: "Com anos de experiência em projetos complexos de TI, nossa equipe combina conhecimento técnico profundo com visão estratégica de negócios. Não somos apenas executores de tarefas — somos parceiros que entendem seus objetivos e trabalham incansavelmente para alcançá-los.\n\nNossa taxa de satisfação de clientes supera 98%, e a maioria dos nossos novos projetos vem de indicações. Isso não é coincidência — é resultado de um compromisso inabalável com a qualidade e com o sucesso dos nossos clientes."
  },
  stats: [
    { label: "Projetos Entregues", value: "200+" },
    { label: "Clientes Satisfeitos", value: "98%" },
    { label: "Anos de Experiência", value: "10+" },
    { label: "Uptime Garantido", value: "99.9%" }
  ]
};

export const blogPosts = [
  {
    id: 1,
    slug: "guia-completo-glpi-2025",
    title: "Guia Completo do GLPI em 2025: Tudo que Você Precisa Saber",
    excerpt: "Descubra como o GLPI pode revolucionar a gestão de TI da sua empresa. Desde a instalação até as melhores práticas de configuração.",
    content: "O GLPI (Gestionnaire Libre de Parc Informatique) é uma das ferramentas de gestão de TI mais completas e acessíveis do mercado. Neste guia completo, vamos explorar todas as funcionalidades que fazem do GLPI a escolha ideal para empresas de todos os portes.\n\n## O que é o GLPI?\n\nO GLPI é uma solução open-source para gerenciamento de ativos de TI e service desk. Desenvolvido em PHP, ele oferece um conjunto robusto de funcionalidades que incluem inventário de hardware e software, gestão de tickets, controle de contratos e muito mais.\n\n## Principais Funcionalidades\n\n### Inventário Automatizado\nO GLPI pode se integrar com ferramentas de inventário automático, como o FusionInventory, para manter sua base de ativos sempre atualizada.\n\n### Service Desk Completo\nGerenciamento de incidentes, problemas e requisições com SLAs configuráveis e workflows personalizados.\n\n### Gestão de Contratos\nControle de fornecedores, contratos de manutenção e garantias em um só lugar.\n\n## Por que Escolher o GLPI?\n\n1. **Custo-benefício**: Sendo open-source, elimina custos de licenciamento\n2. **Flexibilidade**: Altamente customizável através de plugins\n3. **Comunidade ativa**: Suporte da comunidade e atualizações frequentes\n4. **Escalabilidade**: Atende desde pequenas empresas até grandes corporações",
    image: null,
    author: "Equipe KC Byte iT",
    date: "2025-08-10",
    tags: ["GLPI", "Gestão de TI", "Help Desk"]
  },
  {
    id: 2,
    slug: "importancia-pentest-empresas",
    title: "A Importância do Pentest para a Segurança da Sua Empresa",
    excerpt: "Entenda por que testes de penetração são essenciais para proteger seus ativos digitais e manter a conformidade com regulamentações.",
    content: "Em um mundo onde ataques cibernéticos se tornam cada vez mais sofisticados, investir em segurança proativa não é mais opcional — é uma necessidade. O pentest (teste de penetração) é uma das ferramentas mais eficazes para identificar vulnerabilidades antes que criminosos o façam.\n\n## O que é Pentest?\n\nPentest é uma simulação autorizada de ataque cibernético contra um sistema, rede ou aplicação. O objetivo é identificar vulnerabilidades que poderiam ser exploradas por atacantes reais.\n\n## Tipos de Pentest\n\n### Black Box\nO testador não tem conhecimento prévio do sistema, simulando um atacante externo.\n\n### White Box\nAcesso total às informações do sistema, permitindo uma análise mais profunda.\n\n### Grey Box\nConhecimento parcial, simulando um atacante interno ou com acesso limitado.\n\n## Benefícios do Pentest\n\n1. **Identificação proativa de vulnerabilidades**\n2. **Conformidade com LGPD e outras regulamentações**\n3. **Proteção da reputação da empresa**\n4. **Redução de riscos financeiros**\n5. **Melhoria contínua da postura de segurança**",
    image: null,
    author: "Equipe KC Byte iT",
    date: "2025-08-05",
    tags: ["Segurança", "Pentest", "Cibersegurança"]
  },
  {
    id: 3,
    slug: "cloudflare-protecao-performance",
    title: "Cloudflare: Proteção e Performance para Seu Site",
    excerpt: "Saiba como o Cloudflare pode acelerar seu site e protegê-lo contra ataques DDoS e outras ameaças.",
    content: "O Cloudflare é uma plataforma que oferece CDN, proteção DDoS, firewall de aplicações web e muito mais. Utilizado por milhões de sites ao redor do mundo, é uma solução essencial para quem busca performance e segurança.\n\n## Como o Cloudflare Funciona?\n\nO Cloudflare atua como um proxy reverso entre seus visitantes e seu servidor. Todo o tráfego passa pela rede global do Cloudflare, que filtra ameaças e cacheia conteúdo para entrega mais rápida.\n\n## Principais Recursos\n\n### CDN Global\nMais de 200 data centers ao redor do mundo garantem que seu conteúdo seja entregue do local mais próximo ao visitante.\n\n### Proteção DDoS\nMitigação automática de ataques DDoS sem impacto na performance.\n\n### WAF (Web Application Firewall)\nProteção contra vulnerabilidades comuns como SQL Injection e XSS.\n\n### SSL/TLS Gratuito\nCriptografia de ponta a ponta sem custo adicional.\n\n## Resultados Típicos\n\n- Redução de 60% no tempo de carregamento\n- Economia de 50% em banda\n- Proteção contra 99% dos ataques automatizados",
    image: null,
    author: "Equipe KC Byte iT",
    date: "2025-07-28",
    tags: ["Cloudflare", "Performance", "Segurança"]
  },
  {
    id: 4,
    slug: "gcp-google-workspace-empresas",
    title: "GCP e Google Workspace: A Dupla Perfeita para Empresas Modernas",
    excerpt: "Descubra como a combinação do Google Cloud Platform com o Google Workspace pode transformar a produtividade da sua equipe.",
    content: "A Google oferece um ecossistema completo para empresas que buscam modernização digital. A combinação do Google Cloud Platform (GCP) com o Google Workspace cria uma infraestrutura poderosa e produtiva.\n\n## Google Cloud Platform (GCP)\n\nO GCP é a plataforma de computação em nuvem da Google, oferecendo serviços de infraestrutura, plataforma e software.\n\n### Principais Serviços\n\n- **Compute Engine**: Máquinas virtuais escaláveis\n- **Cloud Storage**: Armazenamento de objetos ilimitado\n- **BigQuery**: Data warehouse serverless\n- **Cloud Run**: Execução de containers serverless\n\n## Google Workspace\n\nAnteriormente conhecido como G Suite, o Google Workspace é a suíte de produtividade empresarial da Google.\n\n### Ferramentas Incluídas\n\n- Gmail profissional com domínio próprio\n- Google Drive com armazenamento expandido\n- Google Meet para videoconferências\n- Google Docs, Sheets e Slides\n\n## Benefícios da Integração\n\n1. **Single Sign-On (SSO)** para todas as ferramentas\n2. **Colaboração em tempo real** sem limites\n3. **Segurança enterprise** com verificação em duas etapas\n4. **Escalabilidade** conforme sua empresa cresce",
    image: null,
    author: "Equipe KC Byte iT",
    date: "2025-07-20",
    tags: ["Google Cloud", "Google Workspace", "Produtividade"]
  },
  {
    id: 5,
    slug: "automacao-n8n-nodejs",
    title: "Automação Inteligente com n8n e Node.js",
    excerpt: "Aprenda como automatizar processos empresariais usando n8n e Node.js para aumentar a produtividade.",
    content: "A automação de processos é uma das formas mais eficazes de aumentar a produtividade e reduzir erros humanos. Com ferramentas como n8n e Node.js, é possível criar workflows poderosos que conectam diferentes sistemas.\n\n## O que é n8n?\n\nO n8n é uma plataforma de automação de workflows open-source que permite conectar diferentes aplicações e serviços sem precisar escrever código.\n\n### Características\n\n- Interface visual drag-and-drop\n- Mais de 200 integrações nativas\n- Self-hosted (seus dados ficam com você)\n- Extensível com código JavaScript/Node.js\n\n## Casos de Uso Comuns\n\n### Marketing Automation\n- Sincronização de leads entre CRM e ferramentas de email\n- Notificações automáticas de novos leads\n\n### Operações\n- Criação automática de tickets no GLPI\n- Alertas de monitoramento em Slack/Teams\n\n### Vendas\n- Atualização automática de pipelines\n- Geração de propostas automatizadas\n\n## Node.js para Automações Customizadas\n\nQuando o n8n não é suficiente, Node.js permite criar automações totalmente customizadas com performance excepcional.",
    image: null,
    author: "Equipe KC Byte iT",
    date: "2025-07-15",
    tags: ["Automação", "n8n", "Node.js"]
  },
  {
    id: 6,
    slug: "lgpd-conformidade-ti",
    title: "LGPD: Como Garantir Conformidade na Sua Infraestrutura de TI",
    excerpt: "Um guia prático para adequar sua empresa às exigências da Lei Geral de Proteção de Dados.",
    content: "A Lei Geral de Proteção de Dados (LGPD) entrou em vigor em 2020 e estabelece regras claras sobre coleta, armazenamento e tratamento de dados pessoais. A não conformidade pode resultar em multas de até 2% do faturamento.\n\n## Princípios da LGPD\n\n1. **Finalidade**: Dados devem ser coletados para propósitos legítimos e específicos\n2. **Adequação**: Compatibilidade do tratamento com as finalidades informadas\n3. **Necessidade**: Limitação ao mínimo necessário\n4. **Transparência**: Informações claras sobre o tratamento\n5. **Segurança**: Medidas técnicas para proteger os dados\n\n## Medidas Técnicas Necessárias\n\n### Inventário de Dados\nMapeie todos os dados pessoais que sua empresa coleta e processa.\n\n### Controle de Acesso\nImplemente o princípio do menor privilégio — cada pessoa acessa apenas o necessário.\n\n### Criptografia\nDados sensíveis devem ser criptografados em repouso e em trânsito.\n\n### Logs e Auditoria\nMantenha registros de quem acessou quais dados e quando.\n\n### Plano de Resposta a Incidentes\nTenha procedimentos claros para responder a vazamentos de dados.\n\n## Como a KC Byte iT Pode Ajudar\n\nOferecemos consultoria completa em conformidade LGPD, desde o diagnóstico inicial até a implementação de controles técnicos e organizacionais.",
    image: null,
    author: "Equipe KC Byte iT",
    date: "2025-07-08",
    tags: ["LGPD", "Compliance", "Segurança"]
  }
];

export const adminCredentials = {
  password: "kcbyteit2025"
};
